import React from 'react';
import { TwitterTimelineEmbed } from 'react-twitter-embed';

import './twitterfeed.css'

const Twitterfeed = () => {
    return (
        <section id='twitterfeed'>
            <div className="centerContent">
                <div className="selfCenter spaceBetween">
                <TwitterTimelineEmbed
                onLoad={function noRefCheck(){}}
                options={{
                    height: 600
                }}
                screenName="gxbudz"
                sourceType="timeline"
                theme="dark"
                />
                </div>
            </div>
        </section>
    )
}

export default Twitterfeed